import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelAutoWrapInlineItem } from '@/ui';
import type { Caller } from '@/signalr';
import { CallerClassificationPanelItem } from '../shared/CallerClassificationPanelItem';
import { ClosePersonContactPanelItem } from '../shared/ClosePersonContactPanelItem';
import { DeviceStatusRow } from './DeviceStatusRow';
import { MobileAppMedicDataPanelItems } from './MobileAppMedicDataPanelItems';

export type MobileAppSectionProps = {
  source: Caller['dataSources']['currentMobileApp'];
  deviceInfo: Caller['deviceInfo'];
  createdAtUtc: string;
};

export function MobileAppSection({ source, deviceInfo, createdAtUtc }: MobileAppSectionProps) {
  const { t } = useTranslation();

  if (source == null) {
    return null;
  }

  return (
    <DataPanel header={t('Incident_InfoPanel_MobileAppData')}>
      <DeviceStatusRow deviceInfo={deviceInfo} internetConnectionType={source.deviceInfo.internetConnectionType} />

      <CallerClassificationPanelItem classification={source.reportedProblems} />

      <MobileAppMedicDataPanelItems medicData={source.medicData} createdAtUtc={createdAtUtc} />

      <DataPanelAutoWrapInlineItem
        title={t('Incident_InfoPanel_PermanentResidence')}
        value={source.permanentResidence?.fullAddress ?? undefined}
        showEmptyPlaceholder
      />

      <DataPanelAutoWrapInlineItem
        title={t('Incident_InfoPanel_Languages')}
        value={source.languages.join(', ')}
        showEmptyPlaceholder
      />

      <ClosePersonContactPanelItem contacts={source.contacts} />
    </DataPanel>
  );
}
